import { defineComponent as t, openBlock as e, createElementBlock as r, normalizeClass as a, renderSlot as n } from "vue";
import { _ as s } from "../../../_plugin-vue_export-helper-dad06003.js";
const i = t({
  name: "RHorizontalList",
  props: {
    wrap: {
      type: String,
      default: "wrap",
      validator: (o) => ["wrap", "nowrap"].includes(o)
    }
  }
});
function l(o, d, p, _, c, u) {
  return e(), r("ul", {
    class: a(["hobi-horizontal-list", `hobi-horizontal-list--${o.wrap}`])
  }, [
    n(o.$slots, "default", {}, void 0, !0)
  ], 2);
}
const z = /* @__PURE__ */ s(i, [["render", l], ["__scopeId", "data-v-1d1d0b4d"]]);
export {
  z as default
};
